import { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import "./App.css";
import "react-loading-skeleton/dist/skeleton.css";
import Landing from "./components/Pages/Landing";
import Creation from "./components/Pages/music/Creation";
import Album from "./components/Pages/music/Album";
import Statistic from "./components/Pages/music/Statistic";
import Wallet from "./components/Pages/music/Wallet";
import Layout from "./components/Pages/Layout";
import Login from "./components/Pages/Login";
import Profile from "./components/Pages/Profile";
import devTools from "devtools-detect";
import { AnimatePresence } from "framer-motion";
import { SkeletonTheme } from "react-loading-skeleton";
import { Route, Routes, useNavigate, Navigate } from "react-router-dom";
import ModalLogin from "./components/UI/Login/ModalLogin";
import ModalForgot from "./components/UI/Login/ModalForgot";
import Information from "./components/UI/Profile/ProfileCard/Information";
import Account from "./components/UI/Profile/ProfileCard/Account";
import ChangePassword from "./components/UI/Profile/ProfileCard/ChangePassword";
import Contract from "./components/UI/Profile/ProfileCard/Contract";
import Artists from "./components/UI/Profile/ProfileCard/Artists";
import NotFound from "./components/Pages/NotFound";
import AgreementPage from "./components/Pages/AgreementPage";
import BreakDown from "./components/UI/Profile/ProfileCard/IncomeBreakDown";
import ChooseScreen from "./components/Pages/ChooseScreen";
import KaraokeCreation from "./components/Pages/karaoke/Creation";
import KaraokeWallet from "./components/Pages/karaoke/Wallet";
import KaraokeStatistic from "./components/Pages/karaoke/Statistic";
import KaraokeIncomeBreakDown from "./components/UI/Profile/ProfileCard/KaraokeIncomeBreakDown";
import useIsMobile from "./components/Scripts/useIsMobile";

function App() {
  const navigate = useNavigate();
  const [isUserCanEdit, setIsUserCanEdit] = useState(false);

  const [cookie, setCookie, removeCookie] = useCookies();
  useEffect(() => {
    if (cookie.who_am_i === "publisher") {
      setIsUserCanEdit(true);
    } else {
      setIsUserCanEdit(false);
    }
  }, [cookie]);
  // const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const currentPublisher = localStorage.getItem("Current-Publisher");
  const [sidebarExpanded, setSidebarExpanded] = useState(true);
  const [sidebarMobileExpanded, setSidebarMobileExpanded] = useState(false);
  const isMobileScreen = useIsMobile();

  const [popup, setPopup] = useState(false);
  const [popupType, setPopupType] = useState("");
  const [popupMessage, setPopupMessage] = useState("");

  const [CKPopup, setCKPopup] = useState(false);
  const [CKPopupType, setCKPopupType] = useState("");
  const [CKPopupMessage, setCKPopupMessage] = useState("");

  // Carickao:

  function oneRingRulesAll(commandIs) {
    // Энэ зүгээр бүх газарлуу удамшуулсан ганц функц, хэрвээ child-аас ямар нэгэн функц дуудах шаардлагатай бол энийг ашиглаад дуудаарай, Reference: Бөгжний эзнээс санаа аваад функцээ бичсэнээс нээх сүртэй зүйл байхгүй шүү.
    switch (commandIs) {
      case "logout":
        caseLogoutFunc();
        break;
      // Энийг хүссэнээрээ ингээд ашиглаж болно шүү, дийлэнхи газарлуу дамжуулчихсан байгаа, тэндээсээ oneRingRulesAll("$YOUR_CASE_NAME$") гээд дуудаад ашиглаж болно. Хамгийн оройд нь ажилладаг болхоор ер нь нилээн том Handler шүү
      case "test":
        console.log("test");
        break;

      case "userAgreedContract":
        setPopupMessage("asd");
        setPopupType("info");
        setPopup(true);
        break;

      default:
        console.warn("PARAMETER NEEDS TO BE SOMETHING");
    }
  }
  function caseLogoutFunc() {
    removeCookie("mmusic_token");
    removeCookie("who_am_i");
    localStorage.clear();
    sessionStorage.clear();
    navigate("/login");
    setPopupType("Info");
    setPopupMessage("sessionOut");
    setPopup(true);
  }
  return (
    <div className="App">
      <SkeletonTheme baseColor="#dddddd" highlightColor="#eeeeee">
        <Routes>
          {["music", "karaoke"].map((section) => (
            <Route
              key={section}
              path={section}
              element={<Landing oneRingRulesAll={oneRingRulesAll} />}
            >
              <Route
                element={
                  <Layout
                    isMobileScreen={isMobileScreen}
                    sidebarExpanded={sidebarExpanded}
                    setSidebarExpanded={setSidebarExpanded}
                    sidebarMobileExpanded={sidebarMobileExpanded}
                    setSidebarMobileExpanded={setSidebarMobileExpanded}
                    currentPublisher={currentPublisher}
                  />
                }
              >
                <Route
                  index
                  element={
                    section === "music" ? (
                      <Wallet oneRingRulesAll={oneRingRulesAll} />
                    ) : (
                      <KaraokeWallet oneRingRulesAll={oneRingRulesAll} />
                    )
                  }
                />
                <Route
                  path="statistic"
                  element={
                    section === "music" ? (
                      <Statistic oneRingRulesAll={oneRingRulesAll} />
                    ) : (
                      <KaraokeStatistic oneRingRulesAll={oneRingRulesAll} />
                    )
                  }
                />
                <Route
                  path="creation"
                  element={
                    section === "music" ? (
                      <Creation oneRingRulesAll={oneRingRulesAll} />
                    ) : (
                      <KaraokeCreation oneRingRulesAll={oneRingRulesAll} />
                    )
                  }
                />
                {section === "music" && (
                    <Route path="album" element={<Album />} />
                )}
                <Route
                  path="incomebreakdown"
                  element={
                    section === "music" ? (
                      <BreakDown
                        isUserCanEdit={isUserCanEdit}
                        CKPopupType={CKPopupType}
                        CKPopupMessage={CKPopupMessage}
                        CKPopup={CKPopup}
                        setCKPopup={setCKPopup}
                      />
                    ) : (
                      <KaraokeIncomeBreakDown
                        isUserCanEdit={isUserCanEdit}
                        CKPopupType={CKPopupType}
                        CKPopupMessage={CKPopupMessage}
                        CKPopup={CKPopup}
                        setCKPopup={setCKPopup}
                      />
                    )
                  }
                />

                <Route
                  path="profile"
                  element={
                    <Profile
                      isUserCanEdit={isUserCanEdit}
                      CKPopupType={CKPopupType}
                      CKPopupMessage={CKPopupMessage}
                      CKPopup={CKPopup}
                      setCKPopup={setCKPopup}
                    />
                  }
                >
                  <Route
                    index
                    element={
                      <Information
                        oneRingRulesAll={oneRingRulesAll}
                        isUserCanEdit={isUserCanEdit}
                        setCKPopup={setCKPopup}
                        setCKPopupType={setCKPopupType}
                        setCKPopupMessage={setCKPopupMessage}
                      />
                    }
                  />
                  <Route
                    path="account"
                    element={
                      <Account
                        oneRingRulesAll={oneRingRulesAll}
                        isUserCanEdit={isUserCanEdit}
                        setCKPopup={setCKPopup}
                        setCKPopupType={setCKPopupType}
                        setCKPopupMessage={setCKPopupMessage}
                      />
                    }
                  />
                  {isUserCanEdit && (
                    <Route
                      path="password"
                      element={
                        <ChangePassword
                          oneRingRulesAll={oneRingRulesAll}
                          setCKPopup={setCKPopup}
                          setCKPopupType={setCKPopupType}
                          setCKPopupMessage={setCKPopupMessage}
                        />
                      }
                    />
                  )}
                  <Route
                    path="contract"
                    element={
                      <Contract
                        oneRingRulesAll={oneRingRulesAll}
                        setCKPopup={setCKPopup}
                        setCKPopupType={setCKPopupType}
                        setCKPopupMessage={setCKPopupMessage}
                      />
                    }
                  />
                  <Route
                    path="artists"
                    element={
                      <Artists
                        oneRingRulesAll={oneRingRulesAll}
                        isUserCanEdit={isUserCanEdit}
                        setCKPopup={setCKPopup}
                        setCKPopupType={setCKPopupType}
                        setCKPopupMessage={setCKPopupMessage}
                      />
                    }
                  />
                  <Route
                    path="*"
                    element={
                      <div className="flex flex-row  justify-center items-center">
                        <h5 className="font-semibold pt-10">
                          Алдаатай Route байна.
                        </h5>
                      </div>
                    }
                  />
                </Route>

                <Route path="*" element={<NotFound />} />
              </Route>
            </Route>
          ))}

          <Route path="/update-agreement" element={<AgreementPage />} />
          <Route
            path="/"
            element={
              <ChooseScreen
                oneRingRulesAll={oneRingRulesAll}
                popup={popup}
                popupType={popupType}
                popupMessage={popupMessage}
                setPopup={setPopup}
              />
            }
          />
          <Route
            path="/login"
            element={
              <Login
                popup={popup}
                popupType={popupType}
                popupMessage={popupMessage}
                setPopup={setPopup}
              />
            }
          >
            <Route
              index
              element={
                <ModalLogin
                  setPopup={setPopup}
                  setPopupMessage={setPopupMessage}
                  setPopupType={setPopupType}
                />
              }
            />

            <Route
              path="forgot"
              element={
                <ModalForgot
                  setPopup={setPopup}
                  setPopupMessage={setPopupMessage}
                  setPopupType={setPopupType}
                />
              }
            />
          </Route>
        </Routes>
      </SkeletonTheme>
    </div>
  );
}

export default App;
